import * as React from 'react'

import {stringifyId} from '../../../types'
import {BS} from '../../../types/BS_types'
import type {StatusPopup} from '../../../types/BS_types'
import PopupControl from '../../classic/PopupControl/PopupControl'

import type {Props} from './BuildStatus.types'
import BuildStatusLink from './BuildStatusLink/BuildStatusLink.container'

import styles from './BuildStatus.css'

class BuildStatus extends React.PureComponent<Props> {
  showPopupCommand: (arg0: React.SyntheticEvent<HTMLSpanElement> | Event) => void = e => {
    const {buildTypeId, state} = this.props
    const popup = this.getPopup()
    popup &&
      buildTypeId &&
      e.currentTarget != null &&
      popup.showPopup(buildTypeId, state === 'finished', false, e.currentTarget)
  }

  hidePopupCommand: () => void = () => {
    const popup = this.getPopup()
    popup?.hidePopup()
  }

  stopHidingPopupCommand: () => void = () => {
    const popup = this.getPopup()
    popup?.stopHidingPopup()
  }

  getPopup(): StatusPopup | null | undefined {
    if (!BS) {
      return null
    }

    const {state, buildId} = this.props

    if (state === 'queued') {
      // eslint-disable-next-line new-cap
      return BS.PromoDetailsPopupFunc != null ? BS.PromoDetailsPopupFunc(buildId) : null
    }

    // eslint-disable-next-line new-cap
    return BS.BuildResultsPopupTracker?.(buildId)
  }

  renderLink(className?: string): React.ReactNode {
    const {buildId, useNumber, withIcon} = this.props
    return (
      <BuildStatusLink
        className={className}
        buildId={buildId}
        useNumber={useNumber}
        withIcon={withIcon}
      />
    )
  }

  render(): React.ReactNode {
    const {showDropdown, className, buildId} = this.props
    return showDropdown ? (
      <PopupControl
        className={className}
        labelClassName={styles.label}
        showPopupCommand={this.showPopupCommand}
        hidePopupCommand={this.hidePopupCommand}
        stopHidingPopupCommand={this.stopHidingPopupCommand}
        controlId={`results:${stringifyId(buildId)}`}
      >
        {this.renderLink()}
      </PopupControl>
    ) : (
      this.renderLink(className)
    )
  }
}

export default BuildStatus
